import type { FirearmBuild } from '../../app/models/build'
import { isAkPlatform } from './zoneCategoryMap'

const MAGAZINE_CATEGORIES = new Set([
  'Magazine',
  'Magazine762',
  'Magazine545',
  'MagazineDrum'
])

function buildHasMagazinePart (build: FirearmBuild): boolean {
  return (build.parts ?? []).some((p) => {
    const c = p.part?.category
    return c != null && MAGAZINE_CATEGORIES.has(c)
  })
}

export type AkIllustrationVariant =
  | 'full'
  | 'drum'
  | 'noMagazine'
  | 'noMagazineStripped';

/**
 * Picks which AKM artwork to show in the workbench:
 * - drum: drum magazine part
 * - noMagazineStripped: no parts yet (bare receiver / no build)
 * - noMagazine: has parts but no magazine part
 * - full: has a standard magazine (non-drum) or other parts with mag
 */
export function getAkIllustrationVariant (build: FirearmBuild | null | undefined): AkIllustrationVariant | undefined {
  if (!build?.firearmModelPlatform || !isAkPlatform(build.firearmModelPlatform)) {
    return undefined
  }
  const parts = build.parts ?? []
  if (parts.some((p) => p.part?.category === 'MagazineDrum')) {
    return 'drum'
  }
  if (parts.length === 0) {
    return 'noMagazineStripped'
  }
  if (!buildHasMagazinePart(build)) {
    return 'noMagazine'
  }
  return 'full'
}
